import { useTranslation } from 'react-i18next';
import { InformationTypes } from '../../../enums';
import { resources } from '../../../resources/resources';
import { Link } from 'react-router-dom';

export default function Links() {
  const { t: translate } = useTranslation();
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <ul className="m-footer-links list-reset">
      <li className="m-footer-copyright">
        {translate(resources.footer.copyright)} &copy; {getCurrentYear()}
      </li>
      <li>
        <Link to={`/information/${InformationTypes.TermsAndConditions}`}>
          {translate(resources.footer.links.termsAndConditions)}
        </Link>
      </li>
      <li>
        <Link to={`/information/${InformationTypes.PrivacyPolicy}`}>
          {translate(resources.footer.links.privacyPolicy)}
        </Link>
      </li>
      <li>
        <Link to="/gdpr">{translate(resources.footer.links.gDPR)}</Link>
      </li>
    </ul>
  );
}
